import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import {
  collection,
  getDocs,
  updateDoc,
  doc,
} from 'firebase/firestore';
import styles from '../../styles/RoutePrice.module.css';
import { FaEdit } from 'react-icons/fa';

const customOrder = ['5-10', '11-20', '21-30', '31-40', '41-50', '51-75', '76-100', '100+'];

const RoutePrice = () => {
  const [pricingRules, setPricingRules] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'pricing_rules'));
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const ordered = customOrder
          .map((key) => data.find((d) => d.id === key))
          .filter(Boolean);

        setPricingRules(ordered);
      } catch (error) {
        console.error('Error fetching pricing rules:', error);
      }
    };

    fetchPricing();
  }, []);

  const handleEdit = (rule) => {
    setEditingId(rule.id);
    setEditedData({ ...rule });
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditedData({});
  };

  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'pricing_rules', editingId), editedData);
      setPricingRules((prev) =>
        prev.map((rule) => (rule.id === editingId ? { ...editedData } : rule))
      );
      setEditingId(null);
      setEditedData({});
    } catch (error) {
      console.error('Error updating document:', error);
    }
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const filteredRules = selectedCard
    ? pricingRules.filter((rule) => rule.id === selectedCard)
    : [];

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Route Pricing Rules</h2>

      {/* Cards */}
      <div className={styles.cardGrid}>
        {pricingRules.map((rule) => (
          <div
            key={rule.id}
            className={styles.card}
            onClick={() => setSelectedCard(rule.id)}
            style={{
              border: selectedCard === rule.id ? '2px solid #5e17eb' : 'transparent',
              cursor: 'pointer',
            }}
          >
            <h3 className={styles.cardTitle}>{rule.id}</h3>
            <p className={styles.cardValue}>
              ₹{rule.min_price} - ₹{rule.max_price}
            </p>
            <p>
              Distance: {rule.min_distance} km - {rule.max_distance} km
            </p>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Range</th>
              <th>Rate/km (₹)</th>
              <th>Min Dist (km)</th>
              <th>Min Price (₹)</th>
              <th>Max Dist (km)</th>
              <th>Max Price (₹)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredRules.map((rule) => (
              <tr key={rule.id}>
                <td>{rule.id}</td>

                {editingId === rule.id ? (
                  <>
                    <td>
                      <input
                        type="number"
                        value={editedData.rate_per_km}
                        onChange={(e) => handleChange(e, 'rate_per_km')}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={editedData.min_distance}
                        onChange={(e) => handleChange(e, 'min_distance')}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={editedData.min_price}
                        onChange={(e) => handleChange(e, 'min_price')}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={editedData.max_distance}
                        onChange={(e) => handleChange(e, 'max_distance')}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={editedData.max_price}
                        onChange={(e) => handleChange(e, 'max_price')}
                      />
                    </td>
                    <td>
                      <button
                        onClick={handleSave}
                        className={`${styles.actionBtn} ${styles.saveBtn}`}
                      >
                        Save
                      </button>
                      <button
                        onClick={handleCancel}
                        className={`${styles.actionBtn} ${styles.cancelBtn}`}
                      >
                        Cancel
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td>{rule.rate_per_km}</td>
                    <td>{rule.min_distance}</td>
                    <td>{rule.min_price}</td>
                    <td>{rule.max_distance}</td>
                    <td>{rule.max_price}</td>
                    <td>
                      <FaEdit
                        className={styles.menuIcon}
                        onClick={() => handleEdit(rule)}
                        title="Edit"
                      />
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoutePrice;
